<template>
  <div class="media-library-menu-component" id="library-list">
    <div class="header-container">
      <div class="title">Apphi Library</div>
      <upload-btn target="#library-list" ref="uploadBtn" v-show="!mediaDelete">
        <div class="upload-btn">Upload</div>
      </upload-btn>
    </div>
    <!-- <div class="type-container">
      <hi-tab v-model="tabIndex" :tabList="tabList" class="tab"></hi-tab>
    </div> -->
    <!-- 当图片一张没有且loading已经结束的时候显示空 -->
    <div
      v-show="tabIndex === 0"
      class="list-container"
      :class="{ empty: mediaEmpty }"
    >
      <div
        v-show="mediaEmpty"
        class="empty-text"
        @click="$refs.uploadBtn.uploadMediaClick()"
      >
        Upload Media from Computer
      </div>
      <draggable
        id="mediaLibrary"
        class="drag-list"
        :disabled="disableDrag"
        :move="dragMove"
        @start="start"
        @end="end"
        :list="mediaList.list"
        :options="dragOptions"
        :clone="clone"
      >
        <div
          class="media-item"
          @click="select(item)"
          @mousedown="moveClick(item)"
          v-for="item in mediaList.list"
          :key="item.id"
          v-lazy:background-image="item.coverUrl"
        >
          <div v-if="item.type === 2" class="video-icon"></div>
          <div class="duration">{{ item.durationText }}</div>
          <div
            v-show="mediaDelete"
            class="del-icon"
            :class="{ selected: item.del }"
          ></div>
        </div>
      </draggable>
      <div style="width: 100%; padding: 20px; text-align: center">
        <el-button
          v-show="!mediaListLoading && !mediaLibraryList.end && !mediaEmpty"
          size="mini"
          style="width: 100%"
          @click="loadMoreMedia()"
        >
          Load more
        </el-button>
        <div v-show="mediaListLoading">
          <i class="el-icon-loading"></i> Loading
        </div>
        <div
          v-show="mediaLibraryList.end && !mediaListLoading && !mediaEmpty"
          style="color: rgb(140, 140, 140)"
        >
          end
        </div>
      </div>
    </div>
    <!--save-->
    <div
      v-show="tabIndex === 1"
      id="saved-list"
      class="list-container"
      :class="{ empty: savedEmpty }"
    >
      <draggable
        id="saveLibrary"
        class="drag-list"
        :move="dragMove"
        :list="savedLibraryList.list"
        :options="dragOptions"
        :disabled="disableDrag"
        @start="start"
        @end="end"
        :clone="clone"
      >
        <div
          class="media-item"
          @click="savedSelected(item)"
          @mousedown="moveClick(item)"
          v-for="item in savedLibraryList.list"
          :key="item.mediaId"
          v-lazy:background-image="item.coverUrl"
        >
          <div v-if="item.mediaList[0].type === 2" class="video-icon"></div>
          <div class="media-info">
            <div class="info-item">
              <div class="icon like"></div>
              <div class="num-text">{{ item.likeNum | numAbbreviation }}</div>
            </div>
            <div class="info-item" v-show="item.hasVideo">
              <div class="icon view"></div>
              <div class="num-text">{{ item.viewNum | numAbbreviation }}</div>
            </div>
            <div class="info-item">
              <div class="icon common"></div>
              <div class="num-text">
                {{ item.commentNum | numAbbreviation }}
              </div>
            </div>
          </div>
          <div class="mul-icon" v-if="item.images.length > 1"></div>
        </div>
      </draggable>
      <div style="width: 100%; padding: 20px; text-align: center">
        <el-button
          v-show="!savedListLoading && !savedLibraryList.end"
          size="mini"
          style="width: 100%"
          @click="loadSavedMoreMedia()"
        >
          Load more
        </el-button>
        <div v-show="savedListLoading">
          <i class="el-icon-loading"></i> Loading
        </div>
        <div
          v-show="savedLibraryList.end && !savedListLoading"
          style="color: rgb(140, 140, 140)"
        >
          end
        </div>
      </div>
    </div>
    <!--下方数据-->
    <div v-show="tabIndex === 0">
      <div class="bottom-container" v-show="!mediaDelete">
        <div class="del-btn" @click="mediaDelete = true">Delete</div>
        <div class="total-text">{{ mediaList.count }} Total</div>
      </div>
      <div class="bottom-container" v-show="mediaDelete">
        <div class="del-btn" @click="mediaDelete = false">Cancel</div>
        <div class="del-btn" @click="delMedia">Delete</div>
      </div>
    </div>
    <div v-show="tabIndex === 1" class="bottom-container">
      <div class="del-btn"></div>
      <div class="total-text">{{ savedLibraryList.count }} Total</div>
    </div>
  </div>
</template>
<style lang="less">
.media-library-menu-component {
  .el-loading-mask {
    z-index: 99;
  }

  .media-item {
    width: 105px;
    height: 105px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-bottom: 1px;
    margin-right: 1px;
    background-size: cover;
    background-position: center;
    position: relative;
    display: inline-flex;

    .mul-icon {
      background-image: url("../../../public/images/library/album@3x.png");
      width: 20px;
      height: 20px;
      background-size: contain;
      background-position: center;
      position: absolute;
      right: 5px;
      top: 5px;
    }

    .video-icon {
      width: 55px;
      height: 55px;
      z-index: 2;
      background-size: cover;
      background-image: url("../../../public/images/schedule_posts/list/video.png");
      position: absolute;
    }

    .del-icon {
      position: absolute;
      z-index: 9;
      bottom: 0;
      right: 0;
      width: 44px;
      height: 44px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      background-image: url("../../../public/images/common/Normal@3x.png");

      &.selected {
        background-image: url("../../../public/images/common/Select@3x.png");
      }
    }

    .duration {
      position: absolute;
      right: 5px;
      bottom: 5px;
      color: white;
      font-size: 13px;
    }

    .media-info {
      position: absolute;
      left: 5px;
      right: 5px;
      bottom: 5px;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.2);
      display: flex;
      align-items: center;
      justify-content: space-around;

      .info-item {
        display: flex;
        align-items: center;
        color: white;
        flex-direction: column;
        padding: 2px 0;

        &:first-child {
          margin-left: 0;
        }

        .icon {
          background-size: contain;
          width: 13px;
          height: 13px;
          margin-right: 2px;
          filter: invert(100%);
          position: relative;
          bottom: 1px;

          &.like {
            background-image: url("../../../public/images/schedule_posts/list/icon_like@3x.png");
          }

          &.common {
            background-image: url("../../../public/images/schedule_posts/list/icon_com@3x.png");
          }

          &.view {
            background-image: url("../../../public/images/schedule_posts/list/icon_view@3x.png");
          }
        }

        .num-text {
          font-size: 10px;
          -webkit-transform: scale(0.8);
          text-transform: lowercase;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
@import "../../assets/style/theme";

.drag-list {
  font-size: 0;
}

.media-library-menu-component {
  height: 100vh;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #eceff1;

  .upload-btn,
  .del-btn {
    font-size: 16px;
    font-weight: 500;
    color: @color-primary;
    cursor: pointer;

    &:hover,
    &:active {
      opacity: 0.8;
    }
  }

  .header-container {
    height: 80px;
    border-bottom: 1px solid #eceff1;
    display: flex;
    align-items: center;
    padding: 0 16px;
    justify-content: space-between;

    .title {
      font-size: 16px;
      font-weight: 500;
    }
  }

  .type-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px 0 20px;
  }

  .bottom-container {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    border-top: 1px solid #ebedf8;

    .total-text {
      font-size: 16px;
    }
  }

  .list-container {
    display: flex;
    width: 318px;
    flex-wrap: wrap;
    background: white;
    overflow-y: overlay;
    overflow-x: hidden;
    flex: 1;
    align-content: flex-start;

    &.empty {
      align-content: center;
      justify-content: center;

      .empty-text {
        color: rgba(140, 140, 140);
        cursor: pointer;
        text-decoration: underline;
        font-size: 14px;
      }
    }
  }
}
</style>

<script>
import { loadMore, loadSavedMore, delGallery } from "../../service/media";
import { mapGetters } from "vuex";
import {
  MEDIA_LIBRARY_LIST,
  SAVED_LIBRARY_LIST,
} from "../../store/mutation-types";
import { showErrorMsg } from "../../utils/errors";
import uploadBtn from "../../components/library_menu/UploadBtn";
import draggable from "vuedraggable";
import _ from "lodash";
import { guid } from "../../utils";
import { numAbbreviation } from "../../filters/schedule";
import { formatFormInfo } from "../../service/post";
import { getCaptionComment, getSavedCaption } from "../../service/publisher";

export default {
  name: "MediaLibraryMenuComponent",
  filters: { numAbbreviation },
  components: {
    uploadBtn,
    draggable,
  },
  model: {
    prop: "value",
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dragMove: {
      type: Function,
      default: () => {
        if (this.$route.query.type === "bulk") {
          return true;
        }
        return false;
      },
    },
  },
  computed: {
    ...mapGetters({
      savedLibraryList: SAVED_LIBRARY_LIST,
      mediaLibraryList: MEDIA_LIBRARY_LIST,
    }),
    disableDrag() {
      // 当bluk text only则禁止拖拽
      return this.$route.query.bulkType === "text";
    },
    dragOptions() {
      if (this.$route.query.type === "bulk") {
        return {
          group: { name: "media", revertClone: true, pull: "clone" },
          forceFallback: true,
          fallbackClass: "media-item",
        };
      } else {
        return {
          group: { name: "media", revertClone: true, pull: "clone" },
          sort: false,
          forceFallback: true,
          fallbackClass: "media-item",
        };
      }
    },
    mediaEmpty() {
      return this.mediaList.list.length === 0 && !this.mediaListLoading;
    },
    savedEmpty() {
      return this.savedLibraryList.list.length === 0 && !this.savedListLoading;
    },
    mediaList() {
      const media = this.mediaLibraryList;
      // 标注对应删除项
      media.list.forEach((item) => {
        if (this.mediaDeleteArray.find((mediaId) => mediaId === item.id)) {
          item.del = true;
        } else {
          item.del = false;
        }
      });
      return media;
    },
  },
  data() {
    return {
      tabList: [
        {
          icon: "media",
          title: "Media",
        },
        {
          icon: "saved",
          title: "Saved",
        },
      ],
      tabIndex: 0, // tab当先选中项
      mediaDelete: false, // 是否正处于删除状态
      mediaDeleteArray: [], // 待删除项
      mediaListLoading: false, // media是否在加载中
      savedListLoading: false, // saved是否在加载中
    };
  },
  async created() {
    try {
      await this.loadMoreMedia(true);
      // await this.loadSavedMoreMedia(true)
      // 监听通知是否刷新media
      this.$bus.$on("mediaLibraryReload", () => {
        this.loadMoreMedia(true);
      });
    } catch (e) {
      showErrorMsg(e);
    }
  },
  watch: {
    mediaDelete() {
      // 清空删除项目
      this.mediaDeleteArray = [];
    },
  },
  methods: {
    start(m) {
      this.$bus.$emit("dragStart", m);
      document.getElementById("app").classList.add("drag");
    },
    end(m) {
      this.$bus.$emit("dragEnd", m);
      document.getElementById("app").classList.remove("drag");
    },
    clone(m) {
      const { caption, firstComment } = getCaptionComment({ type: "schedule" });
      let result = {};
      if (this.$route.query.type === "drag") {
        const clone = _.cloneDeep(m);
        clone.id = guid();
        clone.from = "add";
        clone.fromType = "drag";
        clone.tempForm = {
          caption,
          firstComment,
        };
        // 说明是saved 则调整默认的repost信息
        if (clone.form) {
          clone.tempForm.caption = getSavedCaption({
            username: clone.user.social_username,
            caption: clone.form.caption,
            defaultCaption: clone.tempForm.caption,
          });
        }
        result = clone;
      } else {
        const clone = _.cloneDeep(formatFormInfo({ detail: m }));
        clone.id = guid();
        clone.from = "add";
        clone.fromType = "bulk";
        result = clone;
      }
      return result;
    },
    /**
     * 点击事件
     * @param m 选中项
     * @param simple 是否打开的是简单样式
     */
    select(m, simple = false) {
      // 判断如果是删除模式则开始计数
      if (this.mediaDelete) {
        // 判断是否已经添加过了，如果添加过则进行删除
        const delIndex = this.mediaDeleteArray.findIndex(
          (mediaId) => mediaId === m.id
        );
        if (delIndex > -1) {
          this.mediaDeleteArray.splice(delIndex);
        } else {
          // 将删除的media id添加到结果中
          this.mediaDeleteArray.push(m.id);
        }
      } else {
        this.$emit("select", { medias: [m], simple });
      }
    },
    /**
     * 监听用户选中一个元素然后拖拽到右侧日历
     */
    moveClick(m) {
      // 监听他鼠标抬起事件
      document.onmouseup = (e) => {
        // 判断抬起的时候是否拖到日历容器中
        const calender = document.getElementById("calenderContainer");
        const scheduleMask = document.getElementById("scheduleMask");
        if (calender && calender.contains(e.target)) {
          if (this.tabIndex === 0) {
            this.select(m, true);
          } else {
            this.savedSelected(m);
          }
        }
        document.onmousemove = null;
        document.onmouseup = null;
        if (scheduleMask) {
          scheduleMask.style.display = "none";
        }
      };
      document.onmousemove = (e) => {
        // 判断抬起的时候是否拖到日历容器中
        const calender = document.getElementById("calenderContainer");
        const scheduleMask = document.getElementById("scheduleMask");
        if (calender && calender.contains(e.target)) {
          if (scheduleMask) {
            scheduleMask.style.display = "block";
          }
        } else {
          if (scheduleMask) {
            scheduleMask.style.display = "none";
          }
        }
      };
    },
    savedSelected(m) {
      this.$emit("savedSelected", m);
    },
    /**
     * 加载media更多
     * @returns {Promise.<void>}
     */
    async loadMoreMedia(first) {
      try {
        this.mediaListLoading = true;
        await loadMore({ first });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.mediaListLoading = false;
      }
    },
    /**
     * 加载saved更多
     * @returns {Promise.<void>}
     */
    async loadSavedMoreMedia(first = false) {
      try {
        this.savedListLoading = true;
        await loadSavedMore({ first });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.savedListLoading = false;
      }
    },
    /**
     * 删除media中的选项
     * @returns {Promise<void>}
     */
    async delMedia() {
      // 显示Loading
      const loading = this.$loading({
        target: "#library-list",
        customClass: ".custom-loading",
      });
      try {
        await delGallery({ ids: this.mediaDeleteArray });
        this.mediaDelete = false;
      } catch (e) {
        console.error(e);
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
  },
};
</script>
